import type { Evaluation } from './types';
import { RecordingPrivateNotice } from './RecordingPrivateNotice';

export function SessionEvaluationCard({
  evaluation,
  goalLabel,
  feedbackHidden = false,
}: {
  evaluation: Evaluation;
  goalLabel?: string | null;
  feedbackHidden?: boolean;
}) {
  const strengths = evaluation.strengths ?? [];
  const improvements = evaluation.improvements ?? [];
  return (
    <div className="bg-white rounded-lg border p-5">
      <div className="flex items-center gap-4 mb-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 text-green-800 font-bold text-lg">
          {evaluation.goalScore}
        </div>
        <div>
          <h2 className="font-semibold text-gray-900">Session Evaluation</h2>
          {goalLabel ? (
            <p className="text-xs text-gray-500 mt-0.5">Evaluated against goal: {goalLabel}</p>
          ) : null}
          <span
            className={`text-sm font-medium ${evaluation.goalReached ? 'text-green-600' : 'text-amber-600'}`}
          >
            {evaluation.goalReached ? 'Goal Reached' : 'Goal Not Reached'}
          </span>
        </div>
      </div>
      {feedbackHidden ? (
        <RecordingPrivateNotice />
      ) : (
        <>
          {evaluation.summary ? (
            <p className="text-gray-700 text-sm mb-3">{evaluation.summary}</p>
          ) : null}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {strengths.length > 0 && (
              <div>
                <h3 className="text-sm font-semibold text-green-700 mb-1">Strengths</h3>
                <ul className="text-sm text-gray-600 space-y-1">
                  {strengths.map((s, i) => (
                    <li key={i} className="flex gap-1.5">
                      <span className="text-green-500 shrink-0">+</span>
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {improvements.length > 0 && (
              <div>
                <h3 className="text-sm font-semibold text-amber-700 mb-1">Areas to Improve</h3>
                <ul className="text-sm text-gray-600 space-y-1">
                  {improvements.map((s, i) => (
                    <li key={i} className="flex gap-1.5">
                      <span className="text-amber-500 shrink-0">-</span>
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
